import React from 'react';
import { useSparkRunByID } from 'hooks/SparkRuns/useSparkRunByID';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';
import SparkRunToolbar from 'components/common/SparkOutputBoard/BoardToolBar/SparkRunToolbar';
import SparkRunOutputItemBoardListViewContainer from './SparkRunOutputItemBoardListViewContainer';
import { ReactFlowProvider } from 'reactflow';
import OutputRatingPanel from './OutputRatingPanel';
import SparkRunningProgressScreen from '../SparkRunningProgressScreen';
import { useBoardNodesByBoardID } from 'hooks/Board';

type OutputItemProps = {
  collectiveSparkRunID: string;
  toggleSidebar: () => void;
  open: boolean;
};

const SparkRunOutputItem = ({
  collectiveSparkRunID,
  toggleSidebar,
  open,
}: OutputItemProps) => {
  const { sparkRun, isLoading: isLoadingSparkRun } =
    useSparkRunByID(collectiveSparkRunID);
  const canReview = sparkRun?.meta.user.permissions?.canReview || true;
  const [panelHidden, setPanelHidden] = React.useState(!canReview || false);
  const { boardNodes, isLoading: isLoadingBoardNodes } = useBoardNodesByBoardID(
    sparkRun?.attributes.outputBoardID
  );
  const handleHide = () => {
    setPanelHidden(true);
  };
  const isLoading = isLoadingSparkRun;

  if (isLoading) {
    return (
      <SparkRunningProgressScreen
        nodeOnly={true}
        showHeader={false}
        sparkID={sparkRun?.attributes.sparkID || ''}
        animate={false}
      />
    );
  }
  return (
    <SparkScrollableGridContainer
      item
      container
      justifySelf='center'
      sx={{
        width: '100%',
        maxWidth: '800px',
        '&. disable_pointer_events': {
          pointerEvents: 'none',
        },
      }}
      justifyContent='center'
      header={
        <>
          <SparkRunToolbar
            boardID={sparkRun?.attributes.outputBoardID || ''}
            toggleSidebar={toggleSidebar}
            open={open}
          />
          {canReview && (
            <OutputRatingPanel
              panelHidden={panelHidden}
              sparkID={sparkRun?.attributes.sparkID}
              handleHide={handleHide}
              ShowCloseIcon={true}
            />
          )}
        </>
      }
      headerStyle={{
        border: 'none',
        height: panelHidden ? '4rem' : '9rem',
        padding: 0,
        marginBottom: 1,
        marginTop: 0.5,
      }}
      scrollableContainerStyle={{
        padding: 0,
        paddingBottom: 2,
      }}
    >
      <ReactFlowProvider>
        <SparkRunOutputItemBoardListViewContainer
          boardNodes={boardNodes}
          isParentLoading={isLoadingBoardNodes}
        />
      </ReactFlowProvider>
    </SparkScrollableGridContainer>
  );
};

export default SparkRunOutputItem;
